module.exports = __webpack_public_path__ + "static/media/sweet16_header.cb2d8091.png";